import { RootState } from 'internal/rootReducer';
import { UserDetailsType } from 'users/types/users';

export const selectUserDetails = (state: RootState): UserDetailsType | null => state.usersState.userDetails;
